// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textarea--description[data-v-5c5da5a1]{height:120px;overflow-y:auto}`, "",{"version":3,"sources":["webpack://./src/components/Editor/Properties/PropertyText.vue"],"names":[],"mappings":"AACA,wCACC,YAAA,CACA,eAAA","sourcesContent":[".textarea--description{height:120px;overflow-y:auto}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
